<template>
  <div class="container">
    <HeadingOne class="-margin-md">口座情報の登録・変更</HeadingOne>

    <NoticeBox class="-error">
      <NoticeHeader>
        <h3 class="heading">エラーが発生しました。</h3>
      </NoticeHeader>
      <NoticeBody>
        <p>
          「口座の登録・変更へ戻る」を押して、改めて口座のご登録をお願いします。
        </p>
        <small
          >※すでにお手続きが完了しているお客さまには、ご登録いただいたメールアドレスに【
          お手続き完了のお知らせ】をお送りしております。</small
        ></NoticeBody
      >
    </NoticeBox>

    <BtngroupSingle class="-margin-lg">
      <BtnMain class="-main" router-name="mb021">
        口座の登録・変更へ戻る
      </BtnMain>
    </BtngroupSingle>
  </div>
  <!-- container -->
</template>

<script>
import { setMeta } from "@/utils/Meta";

import HeadingOne from "@/components/heading/HeadingOne";
import NoticeBox from "@/components/box/NoticeBox";
import NoticeBody from "@/components/box/NoticeBody";
import NoticeHeader from "@/components/box/NoticeHeader";
import BtngroupSingle from "@/components/button/BtngroupSingle";
import BtnMain from "@/components/button/BtnMain";

export default {
  name: "Tem014",
  components: {
    BtnMain,
    BtngroupSingle,
    NoticeHeader,
    NoticeBody,
    NoticeBox,
    HeadingOne,
  },
  setup() {
    setMeta({
      title: "口座情報の登録・変更｜口座情報の登録・変更",
      description:
        "au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,会員,会員サイト,口座情報",
    });
  },
};
</script>

<style scoped></style>
